export const config = {
  propsName: 'renderProps',
  name: 'SpSelectCity',
  type: 'formTmpsConfig',
  icon: 'el-icon-location-information',
  cnName: '地区选择',
  base: {
    title: '地区选择',
    //subtitle: 'SpSelect_subtitle',
    padded: true,
    flex: '1',
    margin: [0, 0, 0, 0],
    selectVal: {
      optionsValue: []
    }
  },
  props: [
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '行政区域选择名称',
        placeholder: '请输入名称'
      },
      value: ''
    },
    {
      type: 'el-input',
      key: 'placeholder',
      bind: {
        label: '提示内容',
        placeholder: '请输入提示内容'
      },
      value: ''
    },

    {
      type: () => import('@/weappTmps/comps/selectCity/index.vue'),
      cmpPath: '/comps/selectCity/index.vue',
      key: 'selectVal',
      bind: {
        label: ''
      },
      value: {
        optionsValue:[]
      }
    }
  ]
}
